import { useEffect, useState } from 'react';
export default function useFormatOptions(options) {
    var _a = useState([]), formattedOptions = _a[0], setFormattedOptions = _a[1];
    useEffect(function () {
        var items = [];
        // eslint-disable-next-line no-restricted-syntax
        for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
            var option = options_1[_i];
            if (typeof option === 'string') {
                option = { value: option, label: option };
            }
            items.push(option);
        }
        setFormattedOptions(items);
    }, [options]);
    return formattedOptions;
}
